
export enum AppointmentStatus {
  Default = 'D',
  Pending = 'P',
  Accepted = 'A',
  Rejected = 'R',
  Withdrawn = 'W'
}
